module.exports = __webpack_public_path__ + "img/Comeon.6f46b5f5.png";